module.exports.API_URL = 'https://api.my.osano.dev';
module.exports.API_NAME = 'Osano B2B CI Api V2';
module.exports.CM_URL = 'https://cmp-ci.osano.com/';
module.exports.CM_LOCALE_URL = 'https://locale.cmp-ci.osano.com/';
module.exports.ASSESSMENTS_API_URL = 'https://assessments-ci.api.osano.com/';
module.exports.LOCAL_API_URL = '';
module.exports.MFA_ISSUER = 'Osano CI';
module.exports.PLANS_URL = 'http://www-osano-com.sandbox.hs-sites.com/plans';
module.exports.DSAR_EMAIL_URL = 'osano.dev';
module.exports.DSAR_FORM_URL = 'https://ci.datasubject.com/';
module.exports.RUDDERSTACK_URL = 'https://datarouter-ci.osano.com/';
module.exports.TRUSTHUB_DOMAIN = 'trusthub.dev';
module.exports.UC_API_URL = 'https://uc.api.osano.dev/v2';
module.exports.UC_CUI_URL = 'https://unifiedconsent.osano.dev';
module.exports.UC_OPT_CSS_URL = 'https://clientapps.osano.dev/uc-opt/latest/ui.css';
module.exports.UC_OPT_JS_URL = 'https://clientapps.osano.dev/uc-opt/latest/ui.js';
module.exports.UC_OPT_EMBED_URL = 'https://clientapps.osano.dev/uc-opt';
module.exports.PRECONFIGURED_CUSTOMER = 'OSANO_PRECONFIGURED';
